export const mutations = {
  SET_IMAGES: (state, action) => {
    state.images = action.images;
  },
  SET_PAGINATION: (state, action) => {
    state.pagination = action.pagination;
  },
  SET_LOADING: (state, action) => {
    state.isLoading = action.isLoading;
  }
};
